import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const client = axios.create({ baseURL: API, withCredentials: true });

export const authApi = {
  me: () => client.get("/auth/me").then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
  exchange: (session_id) => client.post("/auth/session", { session_id }).then((r) => r.data),
  stats: () => client.get("/admin/stats").then((r) => r.data),
  leads: (params) => client.get("/admin/leads", { params }).then((r) => r.data),
  lead: (id) => client.get(`/admin/leads/${id}`).then((r) => r.data),
  setStatus: (id, status) => client.patch(`/admin/leads/${id}`, { status }).then((r) => r.data),
  addNote: (id, text) => client.post(`/admin/leads/${id}/notes`, { text }).then((r) => r.data),
  suppliers: () => client.get("/admin/suppliers").then((r) => r.data),
  createSupplier: (p) => client.post("/admin/suppliers", p).then((r) => r.data),
  updateSupplier: (id, p) => client.patch(`/admin/suppliers/${id}`, p).then((r) => r.data),
  deleteSupplier: (id) => client.delete(`/admin/suppliers/${id}`).then((r) => r.data),
  quotesForLead: (leadId) => client.get(`/admin/leads/${leadId}/quotes`).then((r) => r.data),
  createQuote: (leadId, p) => client.post(`/admin/leads/${leadId}/quotes`, p).then((r) => r.data),
  quote: (id) => client.get(`/admin/quotes/${id}`).then((r) => r.data),
  updateQuote: (id, p) => client.patch(`/admin/quotes/${id}`, p).then((r) => r.data),
  approveQuote: (id) => client.post(`/admin/quotes/${id}/approve`).then((r) => r.data),
  sendQuote: (id) => client.post(`/admin/quotes/${id}/send`).then((r) => r.data),
};

export const usd = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const QUOTE_STATUS_COLORS = {
  draft: "bg-white/5 text-white/50 border-white/15",
  sent: "bg-[#A7D7A0]/15 text-[#A7D7A0] border-[#A7D7A0]/30",
};

export const STATUS_LABELS = {
  new: "New",
  qualified: "Qualified",
  "quote-in-progress": "Quote In Progress",
  "quote-sent": "Quote Sent",
  "awaiting-response": "Awaiting Response",
  approved: "Approved",
  completed: "Completed",
  archived: "Archived",
};

export const STATUS_COLORS = {
  new: "bg-[#FFC857]/15 text-[#FFC857] border-[#FFC857]/30",
  qualified: "bg-sky-400/15 text-sky-300 border-sky-400/30",
  "quote-in-progress": "bg-amber-400/15 text-amber-300 border-amber-400/30",
  "quote-sent": "bg-violet-400/15 text-violet-300 border-violet-400/30",
  "awaiting-response": "bg-orange-400/15 text-orange-300 border-orange-400/30",
  approved: "bg-[#A7D7A0]/15 text-[#A7D7A0] border-[#A7D7A0]/30",
  completed: "bg-[#326B46]/25 text-[#A7D7A0] border-[#326B46]",
  archived: "bg-white/5 text-white/40 border-white/10",
};

export const FACILITY_LABELS = {
  "golf-course": "Golf Course",
  "driving-range": "Driving Range",
  "sports-facility": "Sports Facility",
  "commercial-outdoor": "Commercial Outdoor",
  other: "Other",
};

export const BUDGET_LABELS = {
  "under-25k": "Under $25k",
  "25k-75k": "$25k–$75k",
  "75k-150k": "$75k–$150k",
  "150k-500k": "$150k–$500k",
  "over-500k": "Over $500k",
  "not-sure": "Not sure",
};

export const TIMELINE_LABELS = {
  asap: "ASAP",
  "1-3-months": "1–3 months",
  "3-6-months": "3–6 months",
  "6-12-months": "6–12 months",
  exploring: "Exploring",
};

export const attachmentUrl = (filename) => `${API}/admin/attachments/${filename}`;
